<template>
  <el-table-column
    prop="name"
    sortable="custom"
    label="Rövid név"
    show-overflow-tooltip
    min-width="180"
  >
    <template slot-scope="scope">
      {{ scope.row.company.short_name }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'short_name',
};
</script>
